/***************************************************************************
* リード文の行数でクラスの付替え
***************************************************************************/

const article = document.querySelector('.js-article-item-column');
const articleTxt = article.querySelector('.t-article-item__txt');
const articleTxtNum = articleTxt.textContent.trim().length;

// 31文字より上だと3行用のクラスをつける
if( articleTxtNum > 31 ) {
  article.classList.add('is-3row');
}